<template>
  <el-dialog :visible.sync="visible" :show-close="false" width="1020px">
    <div slot="title" class="ivu-modal-header-inner">
      衍生视频计划 （共选择 <span class="g-error-text"> {{ materialData.length }} </span> 个视频）
    </div>

    <div class="module-content">
      <VideoProcess ref="videoProcessRef"></VideoProcess>

      <Row class="row-item" :gutter="12">
        <Col span="7" class="col-item">
          <span class="item-field">&nbsp;</span>
        </Col>
        <Col span="12">
          <Button type="warning" :loading="previewing" @click="getPreview">预览衍生视频效果</Button>
        </Col>
      </Row>
    </div>

    <template slot="footer">
      <ElButton type="default" @click="visible = false">取消</ElButton>
      <ElButton type="primary" :loading="loading" @click="asyncSubmit">
        <span v-if="loading">提交中</span>
        <span v-else>确定</span>
      </ElButton>
    </template>

    <preview v-model="preview" :url="previewUrl" />
  </el-dialog>
</template>
<script>
import Preview from '@/components/video/preview.vue'
import VideoProcess from '@/views/material/uploading/components/upload-video-process.vue'
import { creatingTaskCreate, getVideoProcessPreview } from '@/api/material.model'
export default {
  name: 'EditVideoModal',
  components: { Preview, VideoProcess },
  props: {
    value: {
      type: Boolean
    },
    materialData: {
      type: Array,
      required: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      loading: null,
      preview: null,
      previewing: null,
      previewUrl: ''
    }
  },
  methods: {
    async getPreview() {
      const videoProcessValid = await this.$refs.videoProcessRef.validate()
      if (!videoProcessValid) return
      const videoProcess = this.$refs.videoProcessRef.getForm()
      this.previewing = true
      getVideoProcessPreview(videoProcess)
        .then((data) => {
          if (typeof data !== 'symbol') this.previewing = false
          if (data) {
            this.previewUrl = data
            this.preview = true
          }
        })
        .catch((err) => {
          console.error(err)
          this.previewing = false
        })
    },
    async asyncSubmit() {
      const imageList = this.materialData.map((ret) => {
        return { imageDetailId: ret.id, imageId: ret.imageId, videoUrl: ret.field1, width: ret.width, height: ret.height }
      })

      const videoProcessValid = await this.$refs.videoProcessRef.validate()
      if (!videoProcessValid) return
      const videoProcess = this.$refs.videoProcessRef.getForm()

      this.loading = true
      creatingTaskCreate({ imageList, videoProcess })
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (data) {
              const opStore = Object.assign({}, videoProcess, {
                pasted: this.pasted,
                wated: this.wated,
                warned: this.warned,
                extend: this.extend,
                watertype: this.watertype
              })
              this.setOperatorStorage('custom-editvideo', opStore)
              this.$Message.success('批量衍生视频计划提交成功！')
              this.$emit('on-cancel')
              this.$bus.$emit('LoopDispatch')
              this.verify = false
              this.visible = false
            }
          }
        })
        .catch((err) => {
          console.error(err)
          this.loading = false
        })
    }
  }
}
</script>
